export const GET_UPGRADE_PATHS = `
import AFLUpgradeExchange from 0xAFLContracts

access(all) fun main (): {UInt64: UInt64} {
  return AFLUpgradeExchange.getUpgradePaths()
}
`
